import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickUnitsState } from '../../selectors/one-click-units.selector';

export class OneClickUnitDisabler extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickUnitsState).pipe(
      filter(state => !!state),
      map(state => state.loading || state.unitsAvailable.length === 1),
    );
  }
}
